var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{ref:"editor",class:[
        'custom-formula',
        { 'is-valid': _vm.isValid, 'is-invalid': _vm.isInvalid },
    ],attrs:{"id":_vm.id,"content":_vm.contentHtml,"options":_vm.editorOption,"disabled":_vm.disabled},on:{"change":_vm.onChangeFormulaHandler},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})
}
var staticRenderFns = []

export { render, staticRenderFns }